import { FC, ReactNode, useRef } from "react";
import { twMerge } from "tailwind-merge";

import { useScrollRestoration } from "utils/hooks/use-scroll-restoration";

export type ContentSidebarMainProps = {
  bottomPadding?: boolean;
  children: ReactNode | ReactNode[];
  className?: string;
  scrollTrackingId?: string;
};

export const ContentSidebarMain: FC<ContentSidebarMainProps> = ({
  bottomPadding = true,
  children,
  className,
  scrollTrackingId = "",
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useScrollRestoration(scrollTrackingId, containerRef);

  return (
    <div
      className={twMerge(
        "flex-auto overflow-y-auto overscroll-y-contain",
        bottomPadding && "pb-[var(--sidebar-bottom-padding)]",
        className,
      )}
      ref={containerRef}
    >
      {children}
    </div>
  );
};
